// Route `api` cho thực thể `importShipment` (G-DT): JSON của `/v1/import` (lô IB từ BOOKINGDATA, không tiền) → `ImportShipment`.
// Pre-alert / DO chưa có cột ở worker nên để mặc định ('Chờ' / 'ok').
import type { ApiRoute } from '@hana/data';
import type { ImportShipment } from './types';

type Row = Record<string, unknown>;
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** ISO → `dd/MMM/yyyy` (đúng ngày trong chuỗi, không đổi múi giờ); không đọc được thì '—'. */
export function dmy(v: unknown): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(str(v));
  return m ? `${m[3]}/${MON[Number(m[2]) - 1] ?? m[2]}/${m[1]}` : '—';
}

export function importFromApi(r: Row): ImportShipment {
  const vol = str(r.Vol);
  const cont = str(r.TypeCont);
  const qty = vol && cont ? `${vol}×${cont}` : vol || cont;
  const commodity = str(r.Commodity);
  return {
    id: str(r.JobID),
    cus: str(r.ShortName),
    cargo: [commodity, qty].filter(Boolean).join(' · '),
    vessel: str(r.Vessel),
    lane: `${str(r.PoLCode) || str(r.PoL)} → ${str(r.PoDCode) || str(r.PoD)}`,
    eta: dmy(r.ETA),
    preAlert: 'Chờ',
    doState: 'ok',
    refs: [str(r.MBL), str(r.HBL)].filter(Boolean).join(' / '),
  };
}

const items = (json: unknown): Row[] => {
  const list = (json as { items?: unknown } | null)?.items;
  return Array.isArray(list) ? (list as Row[]) : [];
};

export const importApiRoute: ApiRoute<ImportShipment> = {
  path: '/api/v1/import',
  query: (q) => {
    const limit = q.limit && q.limit > 0 ? q.limit : 50;
    return { q: q.q?.trim(), limit, page: Math.floor((q.offset ?? 0) / limit) + 1 };
  },
  parse: (json) => ({ items: items(json).map(importFromApi), hasMore: (json as { hasMore?: boolean } | null)?.hasMore === true }),
  getPath: (id) => `/api/v1/jobs/${encodeURIComponent(id)}`,
  parseOne: (json) => (json && typeof json === 'object' && 'JobID' in json ? importFromApi(json as Row) : null),
};
